import React from "react";

interface FilterIconProps extends React.SVGProps<SVGSVGElement> {
  strokeColor?: string; // optional prop to override
}

const FilterIcon: React.FC<FilterIconProps> = ({ strokeColor, ...props }) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={strokeColor || "rgb(var(--primary))"} // use CSS var
    >
      <path
        d="M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
